// extracted by mini-css-extract-plugin
export default {"BoldComment":"styles_BoldComment__Y6H8g","Comment":"styles_Comment__5xvyH","MailImg":"styles_MailImg__Hq6GL"};